module.exports = __webpack_public_path__ + "files/6fdea2d674d16a2f4ee304d2f155de7e.png";